import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Container, Spinner, Row, Col, Label, FormGroup, Input, Button } from 'reactstrap'
import { request } from '@octokit/request'
import Select from '../../../components/Template/Input/Select'
import Breadcrumbs from '../../../components/Common/Breadcrumb'
import { notifyError, notifySuccess } from '../../../utils/notify'
import { history } from '../../../store'
import { graphClient } from '../../../store/sagas/auth'

class NewFeedback extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      title: '',
      titleInputError: '',
      body: '',
      bodyInputError: '',
      label: null,
      labelInputError: '',
      files: [],
    }
  }

  handleSubmit = async () => {
    const { user } = this.props.auth
    const { title, body, label, files } = this.state

    const siteId = 'ecossissolucoes.sharepoint.com,8a4a0d39-f8bb-47fc-ab5e-9d63be7b5fde,7bab859a-7a2b-4ac2-9ed3-e9bcc6983656'
    const listId = '6745ed16-86d2-4291-96d8-610f193c1bbd'

    if (!body) this.setState({ bodyInputError: 'Campo obrigatório.' })
    if (!label) this.setState({ labelInputError: 'Campo obrigatório.' })
    if (!title) this.setState({ titleInputError: 'Campo obrigatório.' })
    if (!body || !label || !title) return

    try {
      this.setState({ loading: true })

      // Salva no Github Issues
      await request('POST /repos/{owner}/{repo}/issues', {
        headers: {
          authorization: `token ${process.env.REACT_APP_GITHUB_TOKEN}`,
        },
        owner: process.env.REACT_APP_GITHUB_REPO_OWNER,
        repo: process.env.REACT_APP_GITHUB_REPO_NAME,
        title,
        labels: [label],
        body: `## Autor\n Nome: ${user.displayName}\n Email: ${user.mail}\n Assunto: ${label}\n ## Descrição\n ${body}\n ## Anexos\n ${files.length < 1 ? 'N/A' : 'Anexos vão aqui.......'}`,
      })

      // Salva na lista Controle de Requisições (P&D) no Sharepoint
      await graphClient
        .api(`/sites/${siteId}/lists/${listId}/items`)
        .post({
          fields: {
            Title: title,
            Detalhamento: body,
            Projeto: 'Oikos',
            Categoria: label,
          },
        })

      // Envia email para grupo de P&D
      await graphClient
        .api('me/sendMail')
        .post({
          message: {
            subject: `[${label}] ${title}`,
            body: {
              contentType: 'Text',
              content: body,
            },
            toRecipients: [
              {
                emailAddress: {
                  address: 'oikos@ecossis.com.br',
                },
              },
            ],
          },
        })

      this.setState({ loading: false })
      history.push('/')
      notifySuccess('Feedback enviado com sucesso. Agradecemos a contribuição!')
    } catch (err) {
      notifyError(err)
      console.tron.log('Erro ao enviar feedback: ', err)
      this.setState({ loading: false })
    }
  }

  render() {
    const { loading, title, titleInputError, body, bodyInputError, labelInputError } = this.state

    return (
      <div className="page-content">
        <Container fluid>

          <Breadcrumbs
            title="Enviar feedback"
            breadcrumbItems={[]}
          />

          <Row className="mb-3 mt-2">
            <Col lg={5}>
              <p>
                Queremos saber a sua opinião! Ela é muito importante para continuarmos evoluindo no desenvolvimento do Oikos.
              </p>
              <p>
                Caso tenha qualquer dúvida, sugestão, ou tenha identificado algum mal funcionamento, por favor
                nos comunique por meio do formulário abaixo:
              </p>
            </Col>
          </Row>

          <Row>
            <Col xl={3} lg={4} md={4} sm={4}>
              <FormGroup>
                <Label>Assunto</Label>
                <Select
                  className="basic-single"
                  classNamePrefix="select"
                  isClearable={false}
                  isSearchable={false}
                  placeholder="Selecione o assunto..."
                  options={[
                    {
                      value: 'Bug',
                      label: 'Bug',
                    },
                    {
                      value: 'Dúvida',
                      label: 'Dúvida',
                    },
                    {
                      value: 'Sugestão',
                      label: 'Sugestão',
                    },
                  ]}
                  onChange={({ value }) => this.setState({ label: value, labelInputError: '' })}
                />
                {
                  labelInputError
                  && (
                    <span style={{ color: 'red' }}>
                      {labelInputError}
                    </span>
                  )
                }
              </FormGroup>
            </Col>
          </Row>

          <Row>
            <Col xl={3} lg={4} md={4} sm={4}>
              <FormGroup>
                <Label>Título</Label>
                <Input
                  className="form-control"
                  value={title}
                  onChange={e => this.setState({
                    title: e.target.value,
                    titleInputError: '',
                  })}
                />
                {
                  titleInputError
                  && (
                    <span style={{ color: 'red' }}>
                      {titleInputError}
                    </span>
                  )
                }
              </FormGroup>
            </Col>
          </Row>

          <Row>
            <Col xl={3} lg={4} md={4} sm={4}>
              <FormGroup>
                <Label>Descrição</Label>
                <Input
                  className="form-control"
                  type="textarea"
                  value={body}
                  onChange={e => this.setState({
                    body: e.target.value,
                    bodyInputError: '',
                  })}
                />
                {
                  bodyInputError
                  && (
                    <span style={{ color: 'red' }}>
                      {bodyInputError}
                    </span>
                  )
                }
              </FormGroup>
            </Col>
          </Row>

          <Button
            type="button"
            color="primary"
            className="mt-3 waves-effect waves-light"
            disabled={loading}
            onClick={() => this.handleSubmit()}
          >
            Enviar
            {loading && (
              <Spinner size="sm" className="ml-2" />
            )}
          </Button>
        </Container>
      </div>
    )
  }
}

const mapStateToProps = state => ({ auth: state.auth })
export default connect(mapStateToProps)(NewFeedback)
